<template>
  <div>
    <div
      id="uxOutput"
      ref="mathJaxEl"
      class="output panel panel-default black--text"
      v-if="!shrinked"
    >
      <div v-if="code">
        <pre v-html="data"></pre>
      </div>
      <div v-if="!code" v-html="data"></div>
    </div>
    <!-- <div v-if="code" class="panel panel-default black--text"><pre v-html="data">hlello</pre></div> -->
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    },
    shrinked: {
      default: false,
      required: false
    },
    savable: {
      default: false,
      required: false
    },
    code: {
      default: false,
      required: false
    },
    title: {
      default: "Solution",
      required: false
    }
  },
  data() {
    return {
      popupdialog: false
    };
  }
};
</script>

<style scoped>
.output >>> h4 {
  padding: 5px;
}

.output >>> h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
.output >>> h2 {
  font-size: 1.5em;
  margin: 0.75em 0;
}
.output >>> h3 {
  font-size: 1.17em;
  margin: 0.83em 0;
}

.output {
  background-color: white;
  /*
   white-space: pre-wrap; 
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;  
  */
  word-wrap: break-word; /* IE */
  padding-left: 1em;
  padding-right: 1em;
  padding-top: 1em;
  padding-bottom: 3em;
  /* width: 21cm; */
  /* font-family:monospace; */
  /*height: 29.7cm;*/
}

.output >>> h4,
p,
blockquote,
fieldset,
form,
dir,
menu {
  margin: 1.12em 0;
}
.output >>> h5 {
  font-size: 0.83em;
  margin: 1.5em 0;
}
.output >>> h6 {
  font-size: 0.75em;
  margin: 1.67em 0;
}

.output >>> table {
  font-family: monospace;
}

.output >>> pre {
  padding-bottom: 1em;
}

.output >>> .nvs_math {
  margin-top: 2em;
  margin-left: 2em;
  margin-bottom: 3em;
}

.output >>> table {
  border-spacing: 0px;
  /* border-collapse: separate; */
  /* margin: 0px auto; */
}

.output >>> tbody {
  width: 100%;
}

.output >>> td {
  padding: 2px;
}
</style>
